import React from 'react';
import { string, arrayOf, object, bool, number } from 'prop-types';
import FilingStatusCard from './filingStatusCard'

const RefilingStatusCard = props => {    

    const { returnStatii, expandedReturnId, type } = props           
    
    const returnIds = [...new Set(returnStatii.map(item => item.returnid))].sort((a, b) => a.returnid - b.returnid);    
        
    return (        
        returnIds.map((returnId, i, a) =>
            <FilingStatusCard key={'returnType' + i} type={type} returns={returnStatii.filter(item => item.returnid === returnId)} isRefile={a.length - 1 !== i} isCollapsed={returnId.toString() !== expandedReturnId} />
        )        
    )
}

RefilingStatusCard.propTypes = {
    filer: string,
    clientName: string,
    hasAuditProtection: bool,
    returnStatii: arrayOf(object),
    isRefile: bool,
    refileIndex: number,
    isCollapsed: bool
}
export default RefilingStatusCard
